function url_for(uri, htmlext) {
    var prefix = '/pwa/static/'
    // var prefix = '/'
    return prefix + uri + (htmlext === undefined ? '.html' : '')
}

export {url_for}